import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store";
import cookie from "vue-cookies";
import Axios from "axios";
import side from "./components/side";
import top from "./components/top";
import footer from "./components/footer";
import master from "./pages/master";

const maintenance = (resolve) => {
  require.ensure(
    ["./pages/maintenance.vue"],
    () => {
      resolve(require("./pages/maintenance.vue"));
    },
    "maintenance"
  );
};

const login = (resolve) => {
  require.ensure(
    ["./pages/login.vue"],
    () => {
      resolve(require("./pages/login.vue"));
    },
    "login"
  );
};

const fundTags = (resolve) => {
  require.ensure(
    ["./pages/fundTags.vue"],
    () => {
      resolve(require("./pages/fundTags.vue"));
    },
    "fundTags"
  );
};

const allTimes = (resolve) => {
  require.ensure(
    ["./pages/allTimes.vue"],
    () => {
      resolve(require("./pages/allTimes.vue"));
    },
    "allTimes"
  );
};

const dashboard = (resolve) => {
  require.ensure(
    ["./pages/dashboard.vue"],
    () => {
      resolve(require("./pages/dashboard.vue"));
    },
    "dashboard"
  );
};

const setting_mali = (resolve) => {
  require.ensure(
    ["./pages/setting_mali.vue"],
    () => {
      resolve(require("./pages/setting_mali.vue"));
    },
    "setting_mali"
  );
};

const rig_floor_tags = (resolve) => {
  require.ensure(
    ["./pages/rig_floor_tags.vue"],
    () => {
      resolve(require("./pages/rig_floor_tags.vue"));
    },
    "rig_floor_tags"
  );
};

const rigs = (resolve) => {
  require.ensure(
    ["./pages/rigs.vue"],
    () => {
      resolve(require("./pages/rigs.vue"));
    },
    "rigs"
  );
};


const setting_general = (resolve) => {
  require.ensure(
    ["./pages/setting_general.vue"],
    () => {
      resolve(require("./pages/setting_general.vue"));
    },
    "setting_general"
  );
};

const setting_sell = (resolve) => {
  require.ensure(
    ["./pages/setting_sell.vue"],
    () => {
      resolve(require("./pages/setting_sell.vue"));
    },
    "setting_sell"
  );
};

const orders = (resolve) => {
  require.ensure(
    ["./pages/orders.vue"],
    () => {
      resolve(require("./pages/orders.vue"));
    },
    "orders"
  );
};

const permissions = (resolve) => {
  require.ensure(
    ["./pages/permissions.vue"],
    () => {
      resolve(require("./pages/permissions.vue"));
    },
    "permissions"
  );
};

const roles = (resolve) => {
  require.ensure(
    ["./pages/roles.vue"],
    () => {
      resolve(require("./pages/roles.vue"));
    },
    "roles"
  );
};

const users = (resolve) => {
  require.ensure(
    ["./pages/users.vue"],
    () => {
      resolve(require("./pages/users.vue"));
    },
    "users"
  );
};

const employeeWeek = (resolve) => {
  require.ensure(
    ["./pages/employeeWeek.vue"],
    () => {
      resolve(require("./pages/employeeWeek.vue"));
    },
    "employeeWeek"
  );
};

const products = (resolve) => {
  require.ensure(
    ["./pages/products.vue"],
    () => {
      resolve(require("./pages/products.vue"));
    },
    "products"
  );
};

const storeServices = (resolve) => {
  require.ensure(
    ["./pages/storeServices.vue"],
    () => {
      resolve(require("./pages/storeServices.vue"));
    },
    "storeServices"
  );
};

const sections = (resolve) => {
  require.ensure(
    ["./pages/sections.vue"],
    () => {
      resolve(require("./pages/sections.vue"));
    },
    "sections"
  );
};

const projects = (resolve) => {
  require.ensure(
    ["./pages/projects.vue"],
    () => {
      resolve(require("./pages/projects.vue"));
    },
    "projects"
  );
};

const steps = (resolve) => {
  require.ensure(
    ["./pages/steps.vue"],
    () => {
      resolve(require("./pages/steps.vue"));
    },
    "steps"
  );
};

const allKalas = (resolve) => {
  require.ensure(
    ["./pages/allKalas.vue"],
    () => {
      resolve(require("./pages/allKalas.vue"));
    },
    "allKalas"
  );
};

const userTimes = (resolve) => {
  require.ensure(
    ["./pages/userTimes.vue"],
    () => {
      resolve(require("./pages/userTimes.vue"));
    },
    "userTimes"
  );
};

const ordersManager = (resolve) => {
  require.ensure(
    ["./pages/ordersManager.vue"],
    () => {
      resolve(require("./pages/ordersManager.vue"));
    },
    "ordersManager"
  );
};

const orderManager = (resolve) => {
  require.ensure(
    ["./pages/orderManager.vue"],
    () => {
      resolve(require("./pages/orderManager.vue"));
    },
    "orderManager"
  );
};

const order = (resolve) => {
  require.ensure(
    ["./pages/order.vue"],
    () => {
      resolve(require("./pages/order.vue"));
    },
    "order"
  );
};

const forms = (resolve) => {
  require.ensure(
    ["./pages/forms.vue"],
    () => {
      resolve(require("./pages/forms.vue"));
    },
    "forms"
  );
};

const foms = (resolve) => {
  require.ensure(
    ["./pages/foms.vue"],
    () => {
      resolve(require("./pages/foms.vue"));
    },
    "foms"
  );
};

const checks = (resolve) => {
  require.ensure(
    ["./pages/checks.vue"],
    () => {
      resolve(require("./pages/checks.vue"));
    },
    "checks"
  );
};
const stores_archived = (resolve) => {
  require.ensure(
    ["./pages/stores_archived.vue"],
    () => {
      resolve(require("./pages/stores_archived.vue"));
    },
    "stores_archived"
  );
};
const stores = (resolve) => {
  require.ensure(
    ["./pages/stores.vue"],
    () => {
      resolve(require("./pages/stores.vue"));
    },
    "stores"
  );
};
const divisions = (resolve) => {
  require.ensure(
    ["./pages/divisions.vue"],
    () => {
      resolve(require("./pages/divisions.vue"));
    },
    "divisions"
  );
};
const floors = (resolve) => {
  require.ensure(
    ["./pages/floors.vue"],
    () => {
      resolve(require("./pages/floors.vue"));
    },
    "floors"
  );
};

const kalas = (resolve) => {
  require.ensure(
    ["./pages/kalas.vue"],
    () => {
      resolve(require("./pages/kalas.vue"));
    },
    "kalas"
  );
};

const drafts = (resolve) => {
  require.ensure(
    ["./pages/drafts.vue"],
    () => {
      resolve(require("./pages/drafts.vue"));
    },
    "drafts"
  );
};

const hesabs = (resolve) => {
  require.ensure(
    ["./pages/hesabs.vue"],
    () => {
      resolve(require("./pages/hesabs.vue"));
    },
    "hesabs"
  );
};

const factors = (resolve) => {
  require.ensure(
    ["./pages/factors.vue"],
    () => {
      resolve(require("./pages/factors.vue"));
    },
    "factors"
  );
};

const draftsums = (resolve) => {
  require.ensure(
    ["./pages/draftsums.vue"],
    () => {
      resolve(require("./pages/draftsums.vue"));
    },
    "draftsums"
  );
};

const dsums = (resolve) => {
  require.ensure(
    ["./pages/dsums.vue"],
    () => {
      resolve(require("./pages/dsums.vue"));
    },
    "dsums"
  );
};

const kardex = (resolve) => {
  require.ensure(
    ["./pages/kardex.vue"],
    () => {
      resolve(require("./pages/kardex.vue"));
    },
    "kardex"
  );
};

const times = (resolve) => {
  require.ensure(
    ["./pages/times.vue"],
    () => {
      resolve(require("./pages/times.vue"));
    },
    "times"
  );
};

const bills = (resolve) => {
  require.ensure(
    ["./pages/bills.vue"],
    () => {
      resolve(require("./pages/bills.vue"));
    },
    "bills"
  );
};

const allBills = (resolve) => {
  require.ensure(
    ["./pages/allBills.vue"],
    () => {
      resolve(require("./pages/allBills.vue"));
    },
    "allBills"
  );
};

const bill = (resolve) => {
  require.ensure(
    ["./pages/bill.vue"],
    () => {
      resolve(require("./pages/bill.vue"));
    },
    "bill"
  );
};

const dailyChart = (resolve) => {
  require.ensure(
    ["./pages/dailyChart.vue"],
    () => {
      resolve(require("./pages/dailyChart.vue"));
    },
    "dailyChart"
  );
};

const debts = (resolve) => {
  require.ensure(
    ["./pages/debts.vue"],
    () => {
      resolve(require("./pages/debts.vue"));
    },
    "debts"
  );
};

const userBalances = (resolve) => {
  require.ensure(
    ["./pages/userBalances.vue"],
    () => {
      resolve(require("./pages/userBalances.vue"));
    },
    "userBalances"
  );
};

const bimes = (resolve) => {
  require.ensure(
    ["./pages/bimes.vue"],
    () => {
      resolve(require("./pages/bimes.vue"));
    },
    "bimes"
  );
};

const problems = (resolve) => {
  require.ensure(
    ["./pages/problems.vue"],
    () => {
      resolve(require("./pages/problems.vue"));
    },
    "problems"
  );
};

const afters = (resolve) => {
  require.ensure(
    ["./pages/afters.vue"],
    () => {
      resolve(require("./pages/afters.vue"));
    },
    "afters"
  );
};

const ordersAdmin = (resolve) => {
  require.ensure(
    ["./pages/ordersAdmin.vue"],
    () => {
      resolve(require("./pages/ordersAdmin.vue"));
    },
    "ordersAdmin"
  );
};
const ordersAdminList = (resolve) => {
  require.ensure(
    ["./pages/ordersAdminList.vue"],
    () => {
      resolve(require("./pages/ordersAdminList.vue"));
    },
    "ordersAdminList"
  );
};
const ordersManagerList = (resolve) => {
  require.ensure(
    ["./pages/ordersManagerList.vue"],
    () => {
      resolve(require("./pages/ordersManagerList.vue"));
    },
    "ordersManagerList"
  );
};
const orderAdmin = (resolve) => {
  require.ensure(
    ["./pages/orderAdmin.vue"],
    () => {
      resolve(require("./pages/orderAdmin.vue"));
    },
    "orderAdmin"
  );
};

const transactions = (resolve) => {
  require.ensure(
    ["./pages/transactions.vue"],
    () => {
      resolve(require("./pages/transactions.vue"));
    },
    "transactions"
  );
};

const receipts = (resolve) => {
  require.ensure(
    ["./pages/receipts.vue"],
    () => {
      resolve(require("./pages/receipts.vue"));
    },
    "receipts"
  );
};

const files = (resolve) => {
  require.ensure(
    ["./pages/files.vue"],
    () => {
      resolve(require("./pages/files.vue"));
    },
    "files"
  );
};

const ravans = (resolve) => {
  require.ensure(
    ["./pages/ravans.vue"],
    () => {
      resolve(require("./pages/ravans.vue"));
    },
    "ravans"
  );
};

const ravansEdit = (resolve) => {
  require.ensure(
    ["./pages/ravansEdit.vue"],
    () => {
      resolve(require("./pages/ravansEdit.vue"));
    },
    "ravansEdit"
  );
};

const chartsCreate = (resolve) => {
  require.ensure(
    ["./pages/chartsCreate.vue"],
    () => {
      resolve(require("./pages/chartsCreate.vue"));
    },
    "chartsCreate"
  );
};

const envelopes = (resolve) => {
  require.ensure(
    ["./pages/envelopes.vue"],
    () => {
      resolve(require("./pages/envelopes.vue"));
    },
    "envelopes"
  );
};

const envelope = (resolve) => {
  require.ensure(
    ["./pages/envelope.vue"],
    () => {
      resolve(require("./pages/envelope.vue"));
    },
    "envelope"
  );
};

const chartsSell = (resolve) => {
  require.ensure(
    ["./pages/chartsSell.vue"],
    () => {
      resolve(require("./pages/chartsSell.vue"));
    },
    "chartsSell"
  );
};

const doneUsers = (resolve) => {
  require.ensure(
    ["./pages/doneUsers.vue"],
    () => {
      resolve(require("./pages/doneUsers.vue"));
    },
    "doneUsers"
  );
};

const chartsStore = (resolve) => {
  require.ensure(
    ["./pages/chartsStore.vue"],
    () => {
      resolve(require("./pages/chartsStore.vue"));
    },
    "chartsStore"
  );
};

const chartsTarabari = (resolve) => {
  require.ensure(
    ["./pages/chartsTarabari.vue"],
    () => {
      resolve(require("./pages/chartsTarabari.vue"));
    },
    "chartsTarabari"
  );
};

const chartsMali = (resolve) => {
  require.ensure(
    ["./pages/chartsMali.vue"],
    () => {
      resolve(require("./pages/chartsMali.vue"));
    },
    "chartsMali"
  );
};

const opcSteps = (resolve) => {
  require.ensure(
    ["./pages/opcSteps.vue"],
    () => {
      resolve(require("./pages/opcSteps.vue"));
    },
    "opcSteps"
  );
};

const groups = (resolve) => {
  require.ensure(
    ["./pages/groups.vue"],
    () => {
      resolve(require("./pages/groups.vue"));
    },
    "groups"
  );
};

const balance = (resolve) => {
  require.ensure(
    ["./pages/balance.vue"],
    () => {
      resolve(require("./pages/balance.vue"));
    },
    "balance"
  );
};

const tahods = (resolve) => {
  require.ensure(
    ["./pages/tahods.vue"],
    () => {
      resolve(require("./pages/tahods.vue"));
    },
    "tahods"
  );
};

const notices = (resolve) => {
  require.ensure(
    ["./pages/notices.vue"],
    () => {
      resolve(require("./pages/notices.vue"));
    },
    "notices"
  );
};

const my_requests = (resolve) => {
  require.ensure(
    ["./pages/my_requests.vue"],
    () => {
      resolve(require("./pages/my_requests.vue"));
    },
    "my_requests"
  );
};

const garantis = (resolve) => {
  require.ensure(
    ["./pages/garantis.vue"],
    () => {
      resolve(require("./pages/garantis.vue"));
    },
    "garantis"
  );
};

const map = (resolve) => {
  require.ensure(
    ["./pages/map.vue"],
    () => {
      resolve(require("./pages/map.vue"));
    },
    "map"
  );
};

const requests_manager = (resolve) => {
  require.ensure(
    ["./pages/requests_manager.vue"],
    () => {
      resolve(require("./pages/requests_manager.vue"));
    },
    "requests_manager"
  );
};

const cheques = (resolve) => {
  require.ensure(
    ["./pages/cheques.vue"],
    () => {
      resolve(require("./pages/cheques.vue"));
    },
    "cheques"
  );
};

const services = (resolve) => {
  require.ensure(
    ["./pages/services.vue"],
    () => {
      resolve(require("./pages/services.vue"));
    },
    "services"
  );
};

const folder_templates = (resolve) => {
  require.ensure(
    ["./pages/folder_templates.vue"],
    () => {
      resolve(require("./pages/folder_templates.vue"));
    },
    "folder_templates"
  );
};

const odats = (resolve) => {
  require.ensure(
    ["./pages/odats.vue"],
    () => {
      resolve(require("./pages/odats.vue"));
    },
    "odats"
  );
};

const envelopes_all = (resolve) => {
  require.ensure(
    ["./pages/envelopes_all.vue"],
    () => {
      resolve(require("./pages/envelopes_all.vue"));
    },
    "envelopes_all"
  );
};

const envelope_all = (resolve) => {
  require.ensure(
    ["./pages/envelope_all.vue"],
    () => {
      resolve(require("./pages/envelope_all.vue"));
    },
    "envelope_all"
  );
};

const personal_access_tokens = (resolve) => {
  require.ensure(
    ["./pages/personal_access_tokens.vue"],
    () => {
      resolve(require("./pages/personal_access_tokens.vue"));
    },
    "personal_access_tokens"
  );
};

const soorat = (resolve) => {
  require.ensure(
    ["./pages/soorat.vue"],
    () => {
      resolve(require("./pages/soorat.vue"));
    },
    "soorat"
  );
};

const emails = (resolve) => {
  require.ensure(
    ["./pages/emails.vue"],
    () => {
      resolve(require("./pages/emails.vue"));
    },
    "emails"
  );
};

const voip = (resolve) => {
  require.ensure(
    ["./pages/voip.vue"],
    () => {
      resolve(require("./pages/voip.vue"));
    },
    "voip"
  );
};

const contracts = (resolve) => {
  require.ensure(
    ["./pages/contracts.vue"],
    () => {
      resolve(require("./pages/contracts.vue"));
    },
    "contracts"
  );
};

const sell_contracts = (resolve) => {
  require.ensure(
    ["./pages/sell_contracts.vue"],
    () => {
      resolve(require("./pages/sell_contracts.vue"));
    },
    "sell_contracts"
  );
};

const reset = (resolve) => {
  require.ensure(
    ["./pages/reset.vue"],
    () => {
      resolve(require("./pages/reset.vue"));
    },
    "reset"
  );
};

const directs = (resolve) => {
  require.ensure(
    ["./pages/directs.vue"],
    () => {
      resolve(require("./pages/directs.vue"));
    },
    "directs"
  );
};

const profile = (resolve) => {
  require.ensure(
    ["./pages/profile.vue"],
    () => {
      resolve(require("./pages/profile.vue"));
    },
    "profile"
  );
};


const rig_uses = (resolve) => {
  require.ensure(
    ["./pages/rig_uses.vue"],
    () => {
      resolve(require("./pages/rig_uses.vue"));
    },
    "rig_uses"
  );
};

const damages = (resolve) => {
  require.ensure(
    ["./pages/damages.vue"],
    () => {
      resolve(require("./pages/damages.vue"));
    },
    "damages"
  );
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/maintenance",
    name: "maintenance",
    component: maintenance,
  },
  {
    path: "/login",
    name: "login",
    component: login,
    beforeEnter: (to, from, next) => {
      if (store.state.auth) {
        next("/");
      } else if (cookie.get("reval_token") != null) {
        Axios.get(`/v2/auth/checkAdminState`)
          .then((res) => {
            store.state.auth = true;
            store.dispatch("setPermissions", res.data.permissions);
            store.state.name = res.data.user.data.first_name;
            store.state.notices = res.data.notices;
            store.state.family = res.data.user.data.last_name;
            store.state.role = res.data.user.data.role;
            store.state.id = res.data.user.data.id;
            store.state.image = res.data.user.data.image;
            store.state.all_ords = res.data.all_ords;
            store.state.section_ords = res.data.section_ords;
            store.state.orders = res.data.orders;
            store.state.customers = res.data.customers;
            store.state.daily_ords = res.data.daily_ords;
            store.state.wildduck_token = res.data.wildduck_token;
            store.state.voip_token = res.data.voip_token;
            store.state.voip_base_url = res.data.voip_base_url;
            store.state.files_server = res.data.files_server;
            store.state.missions_manager = res.data.missions_manager;
            store.state.vacations_manager = res.data.vacations_manager;
            store.state.aids_manager = res.data.aids_manager;
            store.state.vacations_mali = res.data.vacations_mali;
            store.state.aids_mali = res.data.aids_mali;
            store.state.missions_mali = res.data.missions_mali;
            store.state.tarabaris = res.data.tarabaris;

            if (cookie.get("ravan_reval_status") == "active") {
              next("/counseling-department");
            } else {
              next("/");
            }
          })
          .catch((e) => {
            if (e.response.status == 401) {
              next();
            }
          });
      } else {
        next();
      }
    },
  },
  {
    path: "/",
    components: {
      default: master,
      sidebar: side,
      topbar: top,
      footer: footer,
    },
    children: [
      {
        path: "/",
        name: "dashboard",
        component: dashboard,
        beforeEnter: (to, from, next) => {
          if (cookie.get("ravan_reval_status") == "active") {
            next("/counseling-department");
          } else {
            if (store.state.auth) {
              next();
            } else if (cookie.get("reval_token") != null) {
              Axios.get(`/v2/auth/checkAdminState`)
                .then((res) => {
                  if (res.data.status == "success") {
                    store.state.auth = true;
                    store.dispatch("setPermissions", res.data.permissions);
                    store.state.name = res.data.user.data.first_name;
                    store.state.notices = res.data.notices;
                    store.state.family = res.data.user.data.last_name;
                    store.state.role = res.data.user.data.role;
                    store.state.id = res.data.user.data.id;
                    store.state.image = res.data.user.data.image;
                    store.state.all_ords = res.data.all_ords;
                    store.state.section_ords = res.data.section_ords;
                    store.state.orders = res.data.orders;
                    store.state.customers = res.data.customers;
                    store.state.daily_ords = res.data.daily_ords;
                    store.state.envelopes = res.data.envelopes;
                    store.state.wildduck_token = res.data.wildduck_token;
                    store.state.voip_token = res.data.voip_token;
                    store.state.voip_base_url = res.data.voip_base_url;
                    store.state.files_server = res.data.files_server;
                    store.state.missions_manager = res.data.missions_manager;
                    store.state.vacations_manager = res.data.vacations_manager;
                    store.state.aids_manager = res.data.aids_manager;
                    store.state.vacations_mali = res.data.vacations_mali;
                    store.state.aids_mali = res.data.aids_mali;
                    store.state.missions_mali = res.data.missions_mali;
                    store.state.tarabaris = res.data.tarabaris;
                    next();
                  } else if (res.data.status == "maintenance") {
                    next("/maintenance");
                  } else {
                    next("/login");
                  }
                })
                .catch((e) => {
                  if (e.response.status == 401) {
                    next("/login");
                  }
                });
            } else {
              next("/login");
            }
          }
        },
      },
      {
        path: "/orders",
        name: "orders",
        component: orders,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/permissions",
        name: "permissions",
        component: permissions,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      
      {
        path: "/roles",
        name: "roles",
        component: roles,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/direct-traffic",
        name: "directs",
        component: directs,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/users",
        name: "users",
        component: users,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/voip",
        name: "voip",
        component: voip,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/financial-settings",
        name: "setting_mali",
        component: setting_mali,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      {
        path: "/general-settings",
        name: "setting_general",
        component: setting_general,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      {
        path: "/sales-settings",
        name: "setting_sell",
        component: setting_sell,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_ =
                    res.data.files_server;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      {
        path: "/working-hours",
        name: "times",
        component: times,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/working-hours",
        name: "all_times",
        component: allTimes,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      {
        path: "/bank-accounts",
        name: "hesabs",
        component: hesabs,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/invoices",
        name: "factors",
        component: factors,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/all-products",
        name: "allKalas",
        component: allKalas,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/products",
        name: "products",
        component: products,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/services",
        name: "services",
        component: services,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/outsourced-services",
        name: "storeServices",
        component: storeServices,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/petty-cash-categories",
        name: "fundTags",
        component: fundTags,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/picker",
        name: "doneUsers",
        component: doneUsers,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },


      {
        path: "/map",
        name: "map",
        component: map,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/sections",
        name: "sections",
        component: sections,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/projects",
        name: "projects",
        component: projects,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/orders/steps/:id",
        name: "steps",
        component: steps,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/orders/:id",
        name: "order",
        component: order,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/orders-manager",
        name: "ordersManager",
        component: ordersManager,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/orders-manager/:id",
        name: "orderManager",
        component: orderManager,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/bank-statement/:id",
        name: "soorat",
        component: soorat,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/employee-weekly-schedule/:id",
        name: "employeeWeek",
        component: employeeWeek,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/quality-control-forms",
        name: "forms",
        component: forms,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/quality-control-forms/:id",
        name: "checks",
        component: checks,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      
      {
        path: "/sales-contracts",
        name: "sell_contracts",
        component: sell_contracts,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/archived-inventory",
        name: "stores_archived",
        component: stores_archived,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/warehouses",
        name: "stores",
        component: stores,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/my-requests",
        name: "my_requests",
        component: my_requests,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/requests-management",
        name: "requests_manager",
        component: requests_manager,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      {
        path: "/diviwarehouse-divisionssions/:id",
        name: "divisions",
        component: divisions,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      {
        path: "/sections/:id",
        name: "floors",
        component: floors,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/items/:id",
        name: "kalas",
        component: kalas,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/envelopes/:id",
        name: "envelope",
        component: envelope,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/all-letters/:id",
        name: "envelope_all",
        component: envelope_all,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/all-letters",
        name: "envelopes_all",
        component: envelopes_all,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/stock-transfer-vouchers",
        name: "drafts",
        component: drafts,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/voucher-templates",
        name: "draftsums",
        component: draftsums,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      
      {
        path: "/returned-items",
        name: "odats",
        component: odats,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      
      {
        path: "/notifications",
        name: "notices",
        component: notices,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/payslips",
        name: "bills",
        component: bills,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/payslip-management",
        name: "allBills",
        component: allBills,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/payslips/payslip-details/:id",
        name: "bill",
        component: bill,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/employee-working-hours/:id",
        name: "userTimes",
        component: userTimes,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/voucher-templates/:id",
        name: "dsums",
        component: dsums,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/inventory-ledger/:id",
        name: "kardex",
        component: kardex,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/daily-schedule",
        name: "dailyChart",
        component: dailyChart,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      {
        path: "/folder_templates",
        name: "folder_templates",
        component: folder_templates,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      {
        path: "/form-template-details",
        name: "foms",
        component: foms,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      {
        path: "/profile",
        name: "profile",
        component: profile,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      
      {
        path: "/equipment/:id",
        name: "rigs",
        component: rigs,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/damages/:rig_id",
        name: "damages",
        component: damages,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/groups",
        name: "groups",
        component: groups,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/opc-steps/:id",
        name: "opcSteps",
        component: opcSteps,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/balance/:id",
        name: "userBalances",
        component: userBalances,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/equipment-usages/:rig_id",
        name: "rig_uses",
        component: rig_uses,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },


      {
        path: "/equipment-tags",
        name: "rig_floor_tags",
        component: rig_floor_tags,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/insurances",
        name: "bimes",
        component: bimes,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/service-problems",
        name: "problems",
        component: problems,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/after-sales-services",
        name: "afters",
        component: afters,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/order-management",
        name: "ordersAdmin",
        component: ordersAdmin,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/order-management-list",
        name: "ordersAdminList",
        component: ordersAdminList,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/orders-manager-list",
        name: "ordersManagerList",
        component: ordersManagerList,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/envelopes",
        name: "envelopes",
        component: envelopes,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/order-management/:id",
        name: "orderAdmin",
        component: orderAdmin,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/financial-transactions",
        name: "transactions",
        component: transactions,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/accounting-documents",
        name: "receipts",
        component: receipts,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/document-management",
        name: "files",
        component: files,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/counseling-department",
        name: "ravans",
        component: ravans,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/counseling-department-edit",
        name: "ravansEdit",
        component: ravansEdit,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/charts/production",
        name: "chartsCreate",
        component: chartsCreate,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      {
        path: "/charts/sales",
        name: "chartsSell",
        component: chartsSell,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/charts/warehouse",
        name: "chartsStore",
        component: chartsStore,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      {
        path: "/charts/transportation",
        name: "chartsTarabari",
        component: chartsTarabari,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
      {
        path: "/charts/finance",
        name: "chartsMali",
        component: chartsMali,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/financial-balance",
        name: "balance",
        component: balance,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/warranty",
        name: "garantis",
        component: garantis,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/financial-obligation",
        name: "tahods",
        component: tahods,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/loans",
        name: "debts",
        component: debts,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/cheques",
        name: "cheques",
        component: cheques,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;

                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                console.log(e);
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/contracts",
        name: "contracts",
        component: contracts,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;

                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                console.log(e);
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/personal_access_tokens",
        name: "personal_access_tokens",
        component: personal_access_tokens,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;

                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                console.log(e);
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },

      {
        path: "/emails",
        name: "emails",
        component: emails,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                console.log(e);
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },


      {
        path: "/reset",
        name: "reset",
        component: reset,
        beforeEnter: (to, from, next) => {
          if (store.state.auth) {
            next();
          } else if (cookie.get("reval_token") != null) {
            Axios.get(`/v2/auth/checkAdminState`)
              .then((res) => {
                if (res.data.status == "success") {
                  store.state.auth = true;
                  store.dispatch("setPermissions", res.data.permissions);
                  store.state.name = res.data.user.data.first_name;
                  store.state.notices = res.data.notices;
                  store.state.family = res.data.user.data.last_name;
                  store.state.role = res.data.user.data.role;
                  store.state.id = res.data.user.data.id;
                  store.state.image = res.data.user.data.image;
                  store.state.all_ords = res.data.all_ords;
                  store.state.section_ords = res.data.section_ords;
                  store.state.orders = res.data.orders;
                  store.state.customers = res.data.customers;
                  store.state.daily_ords = res.data.daily_ords;
                  store.state.envelopes = res.data.envelopes;
                  store.state.wildduck_token = res.data.wildduck_token;
                  store.state.files_server = res.data.files_server;
                  store.state.missions_manager = res.data.missions_manager;
                  store.state.vacations_manager = res.data.vacations_manager;
                  store.state.aids_manager = res.data.aids_manager;
                  store.state.vacations_mali = res.data.vacations_mali;
                  store.state.aids_mali = res.data.aids_mali;
                  store.state.missions_mali = res.data.missions_mali;
                  store.state.tarabaris = res.data.tarabaris;
                  next();
                } else if (res.data.status == "maintenance") {
                  next("/maintenance");
                } else {
                  next("/login");
                }
              })
              .catch((e) => {
                console.log(e);
                if (e.response.status == 401) {
                  next("/login");
                }
              });
          } else {
            next("/login");
          }
        },
      },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((toRoute, fromRoute, next) => {
  if (store.state.company_name == "") {
    Axios.get(`/v2/auth/getGeneralSetting`).then((res) => {
      store.state.company_name = res.data.company_name;
      store.state.company_logo = res.data.company_logo;
      document.querySelector("title").textContent =
        res.data.company_name + " | روال سیستم";
    });
  }

  if (window.innerWidth < 500 && toRoute.path.substring(0, 8) == "/charts/") {
    document.querySelector('meta[name="viewport"]').content = "";
  } else {
    document.querySelector('meta[name="viewport"]').content =
      "width=device-width, initial-scale=1";
  }

  const element = document.querySelector(".modal-backdrop");
  if (element != null) {
    element.remove();
  }

  const element2 = document.querySelector(".modal-open");
  if (element2 != null) {
    element2.classList.remove("modal-open");
    element2.style.removeProperty("overflow");
  }

  const element3 = document.querySelector(".sidebar-enable");
  if (element3 != null) {
    element3.classList.remove("sidebar-enable");
  }
  next();
});

export default router;
